// extracted by mini-css-extract-plugin
export default {"item":"_4ed38554","xSmall":"_44d4e086","small":"_9504699e","favorites":"_8f030a66","favoritesWrapper":"_504175d5","favoritesIconWrapper":"_54a5dcbe"};